import React from "react";

export default function DateParagraph(date, content) {
  return (
    <div className="flex gap-[45px] text-left">
      <p className="text-[20px] xl:text-[24px]">{date}</p>
      <p className="text-[20px] xl:text-[24px] whitespace-pre-line">
        {content}
      </p>
    </div>
  );
}
